import { render, staticRenderFns } from "./AchatRappMenu.vue?vue&type=template&id=1747c5ca&scoped=true&"
import script from "./AchatRappMenu.vue?vue&type=script&lang=js&"
export * from "./AchatRappMenu.vue?vue&type=script&lang=js&"
import style0 from "./AchatRappMenu.vue?vue&type=style&index=0&id=1747c5ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747c5ca",
  null
  
)

export default component.exports